// Alief Dispute Hub signature background — a deep-emerald brand backdrop with
// soft metallic-gold light. Two watermark variants:
//   • "text" (default): the large cursive "Alief Dispute Hub" signature. Used
//     everywhere it always was (client portal, intake, reset/forgot, invite) —
//     unchanged.
//   • "mark": the fleur-de-lis brand mark AS the watermark, replacing the
//     cursive text. Used on the staff login only.
// Drop as the first child of a full-screen brand surface and add
// `has-signature-bg` to that surface so its content floats above (z-index 1).
export function SignatureBg({ variant = "text" }: { variant?: "text" | "mark" }) {
  return (
    <div className="bg-fx" aria-hidden="true">
      {variant === "mark" ? (
        <img className="bg-sig-mark" src="/brand-mark.png" alt="" />
      ) : (
        <span className="bg-sig">Alief Dispute Hub</span>
      )}
    </div>
  );
}
